import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import TableToExcel from '@linways/table-to-excel';
import { useForm } from "react-hook-form";
import * as React from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import AccessDenied from '../common/AccessDenied';
import * as leadBankStatementActions from "../../actions/leadBankStatementActions";
import * as leadActions from "../../actions/leadActions";
import CustomerAssessmentNoteViewPage from './CustomerAssessmentNoteViewPage';
// ----------------------------------------------------------------------
const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0), 
}));
// ----------------------------------------------------------------------
const CustomerAssessmentNotePage = (props) => {
 // const { leadId, id } = useParams();
  const location = useLocation();
  const {leadInfo, actions, usersData, fetchLeadIdBankStatement,formCAMValues,formCAMRSMRHCHValues,anchorCategories,speciallyAbledArr ,handleCAMChange,handleCAMRSMRHCHChange,residenceTypesArr,bankingUpiArr,constitutionArr,customerTypeArr, vehicleMakerArr ,vehicleUseArr ,insuranceArr ,vehicleModelsArr ,camTotalPFAmount ,coapplicantGuarantorRows ,handleInputChange ,businessValidationProofArr ,turnoverIncomeArr ,workingCapitalCycleArr ,accountTypeArr ,requirementOptions ,statusOptions ,normsMetOptions,cAMLTVPercentage ,cAMMarginMoney,camIRRExcludingPF,drivingLicenseTypeMasterArr,allDealersArr, dealerName,autoUpdateField,preloaderStatus,userRoleType, handleRSMRHCHDetails,rsmRhChLatestHistoryData} = props; 
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const navigate = useNavigate(); 
  const [file, setFile] = useState('');
  const [pfAmt, SetPfAmt] = useState('');  
    
useEffect(() => { 
 
 }, []);

 const downloadExcel = async () => {
             const table = document.getElementById('DynamicExcelFile');
     
             TableToExcel.convert(table, {
                 name: 'FI-Checklist.xlsx',
                 sheet: {
                     name: 'FI-Checklist',
                 },
             });
         };

  const [showEditDiv, setShowEditDiv] = useState(true);

  const handleToggle = () => {
    setShowEditDiv((prev) => !prev); 
  };   
  
  // section cam PF Amount.
  const totalPfAmt = formCAMValues.cam_pf * formCAMValues.irr_finance_amount;
  const camTotalAsset = formCAMValues.irr_no_of_assets_to_be_financed * formCAMValues.assets_chassis_cost_closed_body;

 // const cAMLTVPercentage1 = (formCAMValues.irr_finance_amount / totalAmountAsPerPerformInvoice) * 100;
 // const camMarginMoney1 = (totalValueCombine - formCAMValues.irr_finance_amount);

  let irrNoOfAssets = formCAMValues.irr_no_of_assets_to_be_financed;  
  let irrFinanceAmount = formCAMValues.irr_finance_amount;
  if(irrNoOfAssets ==='') {
    irrNoOfAssets = 0;
  }
  if(irrFinanceAmount ==='') {
    irrFinanceAmount = 0;
  }

  const camTotalFinanceAmount = irrFinanceAmount * irrNoOfAssets;  
  // const camTotalFinanceAmount = irrFinanceAmount;

  return (
    <>



        <div className="row" >

           <div className="col-md-12" >
              <button
                    type="button"
                    className="btn btn-primary text-white" 
                    onClick={handleToggle}
                >
                    {showEditDiv ? 'View Format' : 'Edit Format'}
                </button>
            </div>  


            
              <div className= {showEditDiv ? "row":"row d-none"}>
                     <div className="col-md-12" >
                       <div className='form-group' >
                         <hr/>
                             <h5 className='text-center text-primary'>Section A : Basic Details</h5>
                         <hr/>
                       </div>
                     </div>
 
                      
                     <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_customer_name">
                         <span>Customer Name</span>
                         <input
                           id='cam_customer_name'
                           name='cam_customer_name'
                           className='form-control'
                           {...register('cam_customer_name')}
                           value={formCAMValues.cam_customer_name}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
             
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_pan_no">
                         <span>PAN No</span>
                         <input
                           id='cam_pan_no'
                           name='cam_pan_no'
                           className='form-control'
                           {...register('cam_pan_no')}
                           value={formCAMValues.cam_pan_no}
                           onChange={handleCAMChange}
                           readOnly="true"
                         />
                         </label>
                       </div>
                       </div>
 
 <div className="col-md-3" >
                         <div className='form-group' >
                           <label htmlFor="lead-profile" >
                             <span>Category</span>
                             <select
                               id='cam_category'
                               name='cam_category'
                               className="form-select"
                               {...register('cam_category')}
                               value={formCAMValues.cam_category}
                               onChange={handleCAMChange}>
                               <option value='' > Select Category </option>
                               {
                                 anchorCategories.length > 0 && anchorCategories.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                           </label>
                         </div>
                       </div> 
 
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_sales_manager">
                         <span>Sales Manager</span>
                         <input
                           id='cam_sales_manager'
                           name='cam_sales_manager'
                           className='form-control'
                           {...register('cam_sales_manager')}
                           value={formCAMValues.cam_sales_manager}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_no_of_vehicles_owned">
                         <span>No. of Vehicles Owned</span>
                         <input
                           id='cam_no_of_vehicles_owned'
                           name='cam_no_of_vehicles_owned'
                           className='form-control'
                           {...register('cam_no_of_vehicles_owned')}
                           value={formCAMValues.cam_no_of_vehicles_owned}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_gender">
                         <span>Gender</span>
                         <input
                           id='cam_gender'
                           name='cam_gender'
                           className='form-control'
                           {...register('cam_gender')}
                           value={formCAMValues.cam_gender}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className="col-md-3" >
                         <div className='form-group' >
                           <label htmlFor="lead-profile" >
                             <span>Specially Abled</span>
                             <select
                               id='cam_specially_abled'
                               name='cam_specially_abled'
                               className="form-select"
                               {...register('cam_specially_abled')}
                               value={formCAMValues.cam_specially_abled}
                               onChange={handleCAMChange}>
                                {
                                speciallyAbledArr.length > 0 && speciallyAbledArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                           </label>
                         </div>
                       </div> 
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_contact_person_name_designation">
                         <span>Contact Person Name & Designation</span>
                         <input
                           id='cam_contact_person_name_designation'
                           name='cam_contact_person_name_designation'
                           className='form-control'
                           {...register('cam_contact_person_name_designation')}
                           value={formCAMValues.cam_contact_person_name_designation}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_address">
                         <span>Current Address -</span>
                         <input
                           id='cam_address'
                           name='cam_address'
                           className='form-control'
                           {...register('cam_address')}
                           value={formCAMValues.cam_address}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_permanent_landmark">
                         <span>Current Landmark</span>
                         <input
                           id='cam_permanent_landmark'
                           name='cam_permanent_landmark'
                           className='form-control'
                           {...register('cam_permanent_landmark')}
                           value={formCAMValues.cam_permanent_landmark}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div>

                        <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_permanent_city">
                         <span>Current City/ Town</span>
                         <input
                           id='cam_permanent_city'
                           name='cam_permanent_city'
                           className='form-control'
                           {...register('cam_permanent_city')}
                           value={formCAMValues.cam_permanent_city}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div>

                        <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_permanent_district">
                         <span>Current District</span>
                         <input
                           id='cam_permanent_district'
                           name='cam_permanent_district'
                           className='form-control'
                           {...register('cam_permanent_district')}
                           value={formCAMValues.cam_permanent_district}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div>


                        <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_permanent_state">
                         <span>Current State</span>
                         <input
                           id='cam_permanent_state'
                           name='cam_permanent_state'
                           className='form-control'
                           {...register('cam_permanent_state')}
                           value={formCAMValues.cam_permanent_state}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div>

                        <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_permanent_pin">
                         <span>Current Pin</span>
                         <input
                           id='cam_permanent_pin'
                           name='cam_permanent_pin'
                           className='form-control'
                           {...register('cam_permanent_pin')}
                           value={formCAMValues.cam_permanent_pin}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div>                      
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_mobile_no">
                         <span>Mobile No.</span>
                         <input
                           id='cam_mobile_no'
                           name='cam_mobile_no'
                           className='form-control'
                           {...register('cam_mobile_no')}
                           value={formCAMValues.cam_mobile_no}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_repayment_mode">
                         <span>Repayment Mode</span>
                         <input
                           id='cam_repayment_mode'
                           name='cam_repayment_mode'
                           className='form-control'
                           {...register('cam_repayment_mode')}
                           value={formCAMValues.cam_repayment_mode}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_credit_free_vehicle">
                         <span>Credit Free Vehicle</span>
                         <input
                           id='cam_credit_free_vehicle'
                           name='cam_credit_free_vehicle'
                           className='form-control'
                           {...register('cam_credit_free_vehicle')}
                           value={formCAMValues.cam_credit_free_vehicle}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_social_category">
                         <span>Social Category</span>
                         <input
                           id='cam_social_category'
                           name='cam_social_category'
                           className='form-control'
                           {...register('cam_social_category')}
                           value={formCAMValues.cam_social_category}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_spouse">
                         <span>SPOUSE Name </span>
                         <input
                           id='cam_spouse'
                           name='cam_spouse'
                           className='form-control'
                           {...register('cam_spouse')}
                           value={formCAMValues.cam_spouse}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_father_name">
                         <span>Father Name </span>
                         <input
                           id='cam_father_name'
                           name='cam_father_name'
                           className='form-control'
                           {...register('cam_father_name')}
                           value={formCAMValues.cam_father_name}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_dob">
                         <span>DOB</span>
                         <input
                           type="date"
                           id='cam_dob'
                           name='cam_dob'
                           className='form-control'
                           {...register('cam_dob')}
                           value={formCAMValues.cam_dob}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_cibil_crif">
                         <span>Cibil/ Crif</span>
                         <input
                           id='cam_cibil_crif'
                           name='cam_cibil_crif'
                           className='form-control'
                           {...register('cam_cibil_crif')}
                           value={formCAMValues.cam_cibil_crif}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
             
 <div className="col-md-3" >
                         <div className='form-group' >
                           <label htmlFor="lead-profile" >
                             <span>Residence </span>
                             <select
                               id='cam_residence_type'
                               name='cam_residence_type'
                               className="form-select"
                               {...register('cam_residence_type')}
                               value={formCAMValues.cam_residence_type}
                               onChange={handleCAMChange}>
                                {
                                 residenceTypesArr.length > 0 && residenceTypesArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                           </label>
                         </div>
                       </div> 
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_current_address_and_city_stability">
                         <span>Permanent Address and City Stability</span>
                         <input
                           id='cam_current_address_and_city_stability'
                           name='cam_current_address_and_city_stability'
                           className='form-control'
                           {...register('cam_current_address_and_city_stability')}
                           value={formCAMValues.cam_current_address_and_city_stability}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>

   <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_new_landmark">
                         <span>Permanent Landmark</span>
                         <input
                           id='cam_new_landmark'
                           name='cam_new_landmark'
                           className='form-control'
                           {...register('cam_new_landmark')}
                           value={formCAMValues.cam_new_landmark}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div>

                        <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_new_city">
                         <span>Permanent City/ Town</span>
                         <input
                           id='cam_new_city'
                           name='cam_new_city'
                           className='form-control'
                           {...register('cam_new_city')}
                           value={formCAMValues.cam_new_city}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div>

                        <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_new_district">
                         <span>Permanent District</span>
                         <input
                           id='cam_new_district'
                           name='cam_new_district'
                           className='form-control'
                           {...register('cam_new_district')}
                           value={formCAMValues.cam_new_district}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div>


                        <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_new_state">
                         <span>Permanent State</span>
                         <input
                           id='cam_new_state'
                           name='cam_new_state'
                           className='form-control'
                           {...register('cam_new_state')}
                           value={formCAMValues.cam_new_state}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div>

                        <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_new_pin">
                         <span>Permanent Pin</span>
                         <input
                           id='cam_new_pin'
                           name='cam_new_pin'
                           className='form-control'
                           {...register('cam_new_pin')}
                           value={formCAMValues.cam_new_pin}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div>                           
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_education">
                         <span>Education</span>
                         <input
                           id='cam_education'
                           name='cam_education'
                           className='form-control'
                           {...register('cam_education')}
                           value={formCAMValues.cam_education}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_source">
                         <span>SOURCE</span>
                         <input
                           id='cam_source'
                           name='cam_source'
                           className='form-control'
                           {...register('cam_source')}
                           value={formCAMValues.cam_source}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_file_charges">
                         <span>FILE CHARGES</span>
                         <input
                           id='cam_file_charges'
                           name='cam_file_charges'
                           className='form-control'
                           {...register('cam_file_charges')}
                           value={formCAMValues.cam_file_charges}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div> 
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_kotak_li_amount">
                         <span>CREDIT LI AMOUNT</span>
                         <input
                           id='cam_kotak_li_amount'
                           name='cam_kotak_li_amount'
                           className='form-control'
                           {...register('cam_kotak_li_amount')}
                           value={formCAMValues.cam_kotak_li_amount}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>

                       <div className="col-md-3" >
                         <div className='form-group' >
                           <label htmlFor="lead-profile" >
                             <span>Who is the driver</span>
                             <select
                               id='cam_who_is_driver'
                               name='cam_who_is_driver'
                               className="form-select"
                               {...register('cam_who_is_driver')}
                               value={formCAMValues.cam_who_is_driver}
                               onChange={handleCAMChange}>
                               <option value='' > Please Select </option>
                               <option value={leadInfo?.data?.[0]?.id}>
                                Applicant ({leadInfo?.data?.[0]?.name})
                              </option>
                               {
                                 coapplicantGuarantorRows.length > 0 && coapplicantGuarantorRows.map((option) => (
                                   <option value={option.id} >{option.type} ({option.name})</option>
                                 ))
                               } 
                             </select>
                           </label>
                         </div>
                       </div> 

                       <div className="col-md-3" >
                         <div className='form-group' >
                           <label htmlFor="lead-profile" >
                             <span>Driving License Type</span>
                             <select
                               id='cam_driving_license_type'
                               name='cam_driving_license_type'
                               className="form-select"
                               {...register('cam_driving_license_type')}
                               value={formCAMValues.cam_driving_license_type}
                               onChange={handleCAMChange}>
                               <option value='' > Please Select </option>
                               {
                                 drivingLicenseTypeMasterArr.length > 0 && drivingLicenseTypeMasterArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                           </label>
                         </div>
                       </div> 
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_dl">
                         <span>Driving License Number</span>
                         <input
                           id='cam_dl'
                           name='cam_dl'
                           className='form-control'
                           {...register('cam_dl')}
                           value={formCAMValues.cam_dl}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className="col-md-3" >
                         <div className='form-group' >
                           <label htmlFor="lead-profile" >
                             <span>BANKING UPI- & CHEQUES</span>
                             <select
                               id='cam_banking_upi'
                               name='cam_banking_upi'
                               className="form-select"
                               {...register('cam_banking_upi')}
                               value={formCAMValues.cam_banking_upi}
                               onChange={handleCAMChange}>
                               <option value='' > Select BANKING UPI </option>
                               {
                                 bankingUpiArr.length > 0 && bankingUpiArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                           </label>
                         </div>
                       </div>    
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_vehicle_use_open">
                         <span>VEHICLE USE -</span>
                         <input
                           id='cam_vehicle_use_open'
                           name='cam_vehicle_use_open'
                           className='form-control'
                           {...register('cam_vehicle_use_open')}
                           value={formCAMValues.cam_vehicle_use_open}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div> 	

                       <div className="col-md-3" >
                         <div className='form-group' >
                           <label htmlFor="lead-profile" >
                             <span>Select Lender</span>
                             <select
                               id='cam_lender'
                               name='cam_lender'
                               className="form-select"
                               {...register('cam_lender')}
                               value={formCAMValues.cam_lender}
                               onChange={handleCAMChange}>
                               <option value='cKers' > cKers </option>
                               <option value='Vivriti' > Vivriti </option>
                             </select>
                           </label>
                         </div>
                       </div> 

                       <div className="col-md-3" >
                         <div className='form-group' >
                           <label htmlFor="lead-profile" >
                             <span>Vehicle Type</span>
                             <select
                               id='cam_vehicle_type'
                               name='cam_vehicle_type'
                               className="form-select"
                               {...register('cam_vehicle_type')}
                               value={formCAMValues.cam_vehicle_type}
                               onChange={handleCAMChange}>
                               <option value="New">New</option>
                                <option value="Used">Used</option>
                             </select>
                           </label>
                         </div>
                       </div> 

                       <div className='col-md-12'>
                           <hr/> 
                            <h6 className='text-primary'>Assets Details :</h6>
                           <br/>
                           </div>
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_consolidated_emi">
                         <span>Consolidated EMI</span>
                         <input
                           id='cam_consolidated_emi'
                           name='cam_consolidated_emi'
                           className='form-control'
                           {...register('cam_consolidated_emi')}
                           value={formCAMValues.cam_consolidated_emi}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_email_id">
                         <span>E-Mail ID</span>
                         <input
                           id='cam_email_id'
                           name='cam_email_id'
                           className='form-control'
                           {...register('cam_email_id')}
                           value={formCAMValues.cam_email_id}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className="col-md-3" >
                         <div className='form-group' >
                           <label htmlFor="lead-profile" >
                             <span>Constitution</span>
                             <select
                               id='cam_constitution'
                               name='cam_constitution'
                               className="form-select"
                               {...register('cam_constitution')}
                               value={formCAMValues.cam_constitution}
                               onChange={handleCAMChange}>
                               <option value='' > Select Constitution </option>
                               {
                                 constitutionArr.length > 0 && constitutionArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                           </label>
                         </div>
                       </div> 
               
               
 <div className="col-md-3" >
                         <div className='form-group' >
                           <label htmlFor="lead-profile" >
                             <span>Customer Type</span>
                             <select
                               id='cam_customer_type'
                               name='cam_customer_type'
                               className="form-select"
                               {...register('cam_customer_type')}
                               value={formCAMValues.cam_customer_type}
                               onChange={handleCAMChange}>
                               <option value='' > Select Customer Type </option>
                               {
                                 customerTypeArr.length > 0 && customerTypeArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                           </label>
                         </div>
                       </div> 
               
               
 <div className="col-md-3" >
                         <div className='form-group' >
                           <label htmlFor="lead-profile" >
                             <span>Vehicle Maker</span>
                             <select
                               id='cam_vehicle_maker'
                               name='cam_vehicle_maker'
                               className="form-select"
                               {...register('cam_vehicle_maker')}
                               value={formCAMValues.cam_vehicle_maker}
                               onChange={handleCAMChange}>
                               <option value='' > Select Vehicle Maker</option>
                               {
                                 vehicleMakerArr.length > 0 && vehicleMakerArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                           </label>
                         </div>
                       </div> 
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_emi_per_vehicle">
                         <span>EMI Per Vehicle</span>
                         <input
                           id='cam_emi_per_vehicle'
                           name='cam_emi_per_vehicle'
                           className='form-control'
                           {...register('cam_emi_per_vehicle')}
                           value={formCAMValues.cam_emi_per_vehicle}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_free_vehicle_percentage">
                         <span>Free Vehicle %</span>
                         <input
                           id='cam_free_vehicle_percentage'
                           name='cam_free_vehicle_percentage'
                           className='form-control'
                           {...register('cam_free_vehicle_percentage')}
                           value={formCAMValues.cam_free_vehicle_percentage}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
             
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_additional_source_of_income">
                         <span>Additional Source of Income</span>
                         <input
                           id='cam_additional_source_of_income'
                           name='cam_additional_source_of_income'
                           className='form-control'
                           {...register('cam_additional_source_of_income')}
                           value={formCAMValues.cam_additional_source_of_income}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className="col-md-3" >
                         <div className='form-group' >
                           <label htmlFor="lead-profile" >
                             <span>Vehicle Use</span>
                             <select
                               id='cam_vehicle_use'
                               name='cam_vehicle_use'
                               className="form-select"
                               {...register('cam_vehicle_use')}
                               value={formCAMValues.cam_vehicle_use}
                               onChange={handleCAMChange}>
                               <option value='' > Select Vehicle Use </option>
                               {
                                 vehicleUseArr.length > 0 && vehicleUseArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                           </label>
                         </div>
                       </div> 
               
               
 <div className="col-md-3" >
                         <div className='form-group' >
                           <label htmlFor="lead-profile" >
                             <span>Insurance</span>
                             <select
                               id='cam_insurance'
                               name='cam_insurance'
                               className="form-select"
                               {...register('cam_insurance')}
                               value={formCAMValues.cam_insurance}
                               onChange={handleCAMChange}>
                               <option value='' > Select Insurance </option>
                               {
                                 insuranceArr.length > 0 && insuranceArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                           </label>
                         </div>
                       </div> 
               
 
 <div className="col-md-3" >
                         <div className='form-group' >
                           <label htmlFor="lead-profile" >
                             <span>Vehicle Model</span>
                             <select
                               id='cam_vehicle_models'
                               name='cam_vehicle_models'
                               className="form-select"
                               {...register('cam_vehicle_models')}
                               value={formCAMValues.cam_vehicle_models}
                               onChange={handleCAMChange}>
                               <option value='' > Select Vehicle model </option>
                               {
                                 vehicleModelsArr.length > 0 && vehicleModelsArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                           </label>
                         </div>
                       </div> 
 
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_dealer_name">
                         <span>Dealer Name</span>
                        {/* <input
                           id='cam_dealer_name'
                           name='cam_dealer_name'
                           className='form-control'
                           {...register('cam_dealer_name')}
                           value={formCAMValues.cam_dealer_name}
                           onChange={handleCAMChange}
                           
                         /> */}

                         <select
                               id='cam_dealer_name'
                               name='cam_dealer_name'
                               className="form-select"
                               {...register('cam_dealer_name')}
                               value={formCAMValues.cam_dealer_name}
                               onChange={handleCAMChange}>
                               <option value='' > Please Select </option>
                               {
                                 allDealersArr.length > 0 && allDealersArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_loan_tenor_in_months">
                         <span>Loan Tenor (in Months)</span>
                         <input
                           id='cam_loan_tenor_in_months'
                           name='cam_loan_tenor_in_months'
                           className='form-control'
                           {...register('cam_loan_tenor_in_months')}
                           value={formCAMValues.cam_loan_tenor_in_months}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_payout">
                         <span>Payout</span>
                         <input
                           id='cam_payout'
                           name='cam_payout'
                           className='form-control'
                           {...register('cam_payout')}
                           value={formCAMValues.cam_payout}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
                       <div className='col-md-12'>
                           <hr/> 
                            <h6 className='text-primary'>Commercials :</h6>
                           <br/>
                           </div>
 
 
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_pf">
                         <span>PF</span>
                         <input
                           id='cam_pf'
                           name='cam_pf'
                           className='form-control'
                           {...register('cam_pf')}
                           value={formCAMValues.cam_pf}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_iarr">
                         <span>IRR</span>
                         <input
                           id='cam_iarr'
                           name='cam_iarr'
                           className='form-control'
                           {...register('cam_iarr')}
                          /* value={camIRRExcludingPF} */
                           value= {formCAMValues.cam_iarr}
                           
                           onChange={handleCAMChange}
                           readOnly="true"
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_location">
                         <span>Location</span>
                         <input
                           id='cam_location'
                           name='cam_location'
                           className='form-control'
                           {...register('cam_location')}
                           value={formCAMValues.cam_location}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_asset_cost">
                         <span>Asset Cost</span>
                         <input
                           id='cam_asset_cost'
                           name='cam_asset_cost'
                           className='form-control'
                           {...register('cam_asset_cost')}
                           value={formCAMValues.cam_asset_cost}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_no_of_asset">
                         <span>No. of Asset</span>
                         <input
                           id='cam_no_of_asset'
                           name='cam_no_of_asset'
                           className='form-control'
                           {...register('cam_no_of_asset')}
                           value={formCAMValues.cam_no_of_asset}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_total_cost">
                         <span>Total Cost</span>
                         <input
                           id='cam_total_cost'
                           name='cam_total_cost'
                           className='form-control'
                           {...register('cam_total_cost')}
                           value={formCAMValues.cam_total_cost}
                           onChange={handleCAMChange}
                           readOnly="true"
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_finance_value">
                         <span>Finance Value</span>
                         <input
                           id='cam_finance_value'
                           name='cam_finance_value'
                           className='form-control'
                           {...register('cam_finance_value')}
                           value={formCAMValues.cam_finance_value}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_ltv">
                         <span>LTV</span>
                         <input
                           id='cam_ltv'
                           name='cam_ltv'
                           className='form-control'
                           {...register('cam_ltv')}
                           value={cAMLTVPercentage.toFixed(2)}
                           onChange={handleCAMChange}
                            readOnly="true"
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_margin_money">
                         <span>Margin Money</span>
                         <input
                           id='cam_margin_money'
                           name='cam_margin_money'
                           className='form-control'
                           {...register('cam_margin_money')}
                           value={cAMMarginMoney}
                           onChange={handleCAMChange}
                            readOnly="true"
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_pf_amount">
                         <span>PF Amount</span>
                         <input
                           id='cam_pf_amount'
                           name='cam_pf_amount'
                           className='form-control'
                           {...register('cam_pf_amount')}
                           value={camTotalPFAmount.toFixed(2)}
                           onChange={handleCAMChange}
                           readOnly="true"
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_flat_irr">
                         <span>FLAT IRR</span>
                         <input
                           id='cam_flat_irr'
                           name='cam_flat_irr'
                           className='form-control'
                           {...register('cam_flat_irr')}
                           value={formCAMValues.cam_flat_irr}
                           onChange={handleCAMChange}
                           readOnly="true"
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="cam_addhar_no">
                         <span>Addhar No</span>
                         <input
                           id='cam_addhar_no'
                           name='cam_addhar_no'
                           className='form-control'
                           {...register('cam_addhar_no')}
                           value={formCAMValues.cam_addhar_no}
                           onChange={handleCAMChange}
                         />
                         </label>
                       </div>
                       </div> 



 
    <div className='col-md-12'>
        <hr/> 
        <h6 className='text-primary'>Reference details :</h6>
        <br/>
    </div>

    <div className='col-md-3'>
        <div className='form-group'>
          <label htmlFor="cam_reference_name_1">
          <span>Reference Name 1</span>
          <input
            id='cam_reference_name_1'
            name='cam_reference_name_1'
            className='form-control'
            {...register('cam_reference_name_1')}
            value={formCAMValues.cam_reference_name_1}
            onChange={handleCAMChange}
          />
          </label>
        </div>
    </div> 

    <div className='col-md-3'>
        <div className='form-group'>
          <label htmlFor="cam_reference_address_1">
          <span>Reference Address 1</span>
          <input
            id='cam_reference_address_1'
            name='cam_reference_address_1'
            className='form-control'
            {...register('cam_reference_address_1')}
            value={formCAMValues.cam_reference_address_1}
            onChange={handleCAMChange}
          />
          </label>
        </div>
    </div>

    <div className='col-md-3'>
        <div className='form-group'>
          <label htmlFor="cam_reference_relationship_1">
          <span>Reference Relationship 1</span>
          <input
            id='cam_reference_relationship_1'
            name='cam_reference_relationship_1'
            className='form-control'
            {...register('cam_reference_relationship_1')}
            value={formCAMValues.cam_reference_relationship_1}
            onChange={handleCAMChange}
          />
          </label>
        </div>
    </div>

    <div className='col-md-3'>
        <div className='form-group'>
          <label htmlFor="cam_reference_phone_1">
          <span>Reference Phone Number 1</span>
          <input
            id='cam_reference_phone_1'
            name='cam_reference_phone_1'
            className='form-control'
            {...register('cam_reference_phone_1')}
            value={formCAMValues.cam_reference_phone_1}
            onChange={handleCAMChange}
          />
          </label>
        </div>
    </div> 

    <div className='col-md-3'>
        <div className='form-group'>
          <label htmlFor="cam_reference_name_2">
          <span>Reference Name 2</span>
          <input
            id='cam_reference_name_2'
            name='cam_reference_name_2'
            className='form-control'
            {...register('cam_reference_name_2')}
            value={formCAMValues.cam_reference_name_2}
            onChange={handleCAMChange}
          />
          </label>
        </div>
    </div> 

    <div className='col-md-3'>
        <div className='form-group'>
          <label htmlFor="cam_reference_address_2">
          <span>Reference Address 2</span>
          <input
            id='cam_reference_address_2'
            name='cam_reference_address_2'
            className='form-control'
            {...register('cam_reference_address_2')}
            value={formCAMValues.cam_reference_address_2}
            onChange={handleCAMChange}
          />
          </label>
        </div>
    </div>

    <div className='col-md-3'>
        <div className='form-group'>
          <label htmlFor="cam_reference_relationship_2">
          <span>Reference Relationship 2</span>
          <input
            id='cam_reference_relationship_2'
            name='cam_reference_relationship_2'
            className='form-control'
            {...register('cam_reference_relationship_2')}
            value={formCAMValues.cam_reference_relationship_2}
            onChange={handleCAMChange}
          />
          </label>
        </div>
    </div>

    <div className='col-md-3'>
        <div className='form-group'>
          <label htmlFor="cam_reference_phone_2">
          <span>Reference Phone Number 2</span>
          <input
            id='cam_reference_phone_2'
            name='cam_reference_phone_2'
            className='form-control'
            {...register('cam_reference_phone_2')}
            value={formCAMValues.cam_reference_phone_2}
            onChange={handleCAMChange}
          />
          </label>
        </div>
    </div>
  
  
  
    
 <div className="col-md-12" >
 <div className='form-group' >
   <hr/>
       <h5 className='text-center text-primary'>Section B: Other's  Details (Need to display the accepted records  - Approved from credit team)</h5>
   <hr/>
 </div>
 </div>
 <div className="col-md-12" >
   <table border="1" className="table">
           <thead>
             <tr>
               <th>Company/Proprietor /Partner/Director/Co applicant / Guarantor Name</th>
               <th>PAN No.</th>
               <th>Father Name</th>
               <th>Aadhar No.</th>
               <th>Age</th>
               <th>Position/Relationship</th>
               <th>Current Address</th>
               <th>Permanent Address</th>
               <th>Office Address</th>
               <th>Contact No.</th>
               
               <th>Reference Name</th>
               <th>Reference Address</th>
               <th>Reference Relationship</th>
               <th>Reference Phone Number</th> 
               <th>Bureau Score</th>
               <th>Education/Experience / Bureau Remarks</th>
             </tr>
           </thead>
           <tbody>
             {coapplicantGuarantorRows.map((row, index) => (
               <tr key={index}>
                 <td> 
                   <input
                     type="text"
                     className='form-control'
                     value={row.name}
                     onChange={(e) => handleInputChange(row.id, "name", e.target.value)}
                     readOnly='true'
                   />
                   {row.status === "1" ? (
                      <span className="text-success">Active</span>
                    ) : (
                      <span className="text-danger">Inactive</span>
                    )}
                 </td>
                 <td>
                 <input
                     type="text"
                     className='form-control'
                     value={row.pan_number}
                     onChange={(e) => handleInputChange(row.id, "pan_number", e.target.value)}
                     readOnly='true'
                   />
 
                 </td>
                 <td>
                   
                 <input
                     type="text"
                     className='form-control'
                     value={row.father_name}
                     onChange={(e) => handleInputChange(row.id, "father_name", e.target.value)}
                     
                   />
                 </td>
                 <td>
                   
                 <input
                     type="text"
                     className='form-control'
                     value={row.adhar_number}
                     onChange={(e) => handleInputChange(row.id, "adhar_number", e.target.value)}
                     readOnly='true'
                   />
                 </td>
                 <td>
                   
                 <input
                     type="date"
                     className='form-control'
                     value={row.dob}
                     onChange={(e) => handleInputChange(row.id, "dob", e.target.value)}
                     readOnly='true'
                   />
                 </td>
                 <td>
                   
                 <input
                     type="text"
                     className='form-control'
                     value={row.relation}
                     onChange={(e) => handleInputChange(row.id, "relation", e.target.value)}
                      
                   />
                 </td>
                 <td>
                   
                 <input
                     type="text"
                     className='form-control'
                     value={row.full_address}
                     onChange={(e) => handleInputChange(row.id, "full_address", e.target.value)}
                      
                   />
                 </td>
                 <td>
                   
                 <input
                     type="text"
                     className='form-control'
                     value={row.permanent_address}
                     onChange={(e) => handleInputChange(row.id, "permanent_address", e.target.value)}
                     
                   />
                 </td>
 
                 <td>
                   
                   <input
                       type="text"
                       className='form-control'
                       value={row.office_address}
                       onChange={(e) => handleInputChange(row.id, "office_address", e.target.value)}
                       
                     />
                   </td>
   
 
                 <td>
                 <input
                     type="text"
                     className='form-control'
                     value={row.mobile}
                     onChange={(e) => handleInputChange(row.id, "mobile", e.target.value)}
                     
                   />
                 </td>
                 
                 <td>
                 <input
                     type="text"
                     className='form-control'
                     value={row.reference_details}
                     onChange={(e) => handleInputChange(row.id, "reference_details", e.target.value)}
                   />
                 </td>

                 <td>
                 <input
                     type="text"
                     className='form-control'
                     value={row.reference_address}
                     onChange={(e) => handleInputChange(row.id, "reference_address", e.target.value)}
                   />
                 </td>
                 <td>
                 <input
                     type="text"
                     className='form-control'
                     value={row.reference_relationship}
                     onChange={(e) => handleInputChange(row.id, "reference_relationship", e.target.value)}
                   />
                 </td>
                 <td>
                 <input
                     type="text"
                     className='form-control'
                     value={row.reference_phone_number}
                     onChange={(e) => handleInputChange(row.id, "reference_phone_number", e.target.value)}
                   />
                 </td>
 
                 <td>
                 <input
                     type="text"
                     className='form-control'
                     value={row.crif_score}
                     onChange={(e) => handleInputChange(row.id, "crif_score", e.target.value)}
                     readOnly="true"
                   />
 
                 </td>
                 <td> 
                 <input
                     type="text"
                     className='form-control'
                     value={row.bureau_remarks}
                     onChange={(e) => handleInputChange(row.id, "bureau_remarks", e.target.value)}
                     
                   />
                 </td> 
               </tr>
             ))}
           </tbody>
         </table>
 </div>

 {/* Profile Details TextArea Start  */}
    <div className="col-md-12" >
      <div className='form-group' >
        <hr/>
            <h5 className='text-center text-primary'> Profile Details :</h5>
        <hr/>
      </div>
    </div>

    <div className='col-md-12'>
      <div className='col-md-3'>     
      <div className='form-group'>
        <label htmlFor="rsm_rh_ch_review">
            <span>RSM/ RH/ CH Review</span>
               <select
                  id='rsm_rh_ch_review'
                  name='rsm_rh_ch_review'
                  className="form-select"
                  {...register('rsm_rh_ch_review')}
                  value={formCAMRSMRHCHValues.rsm_rh_ch_review}
                  onChange={handleCAMRSMRHCHChange}>                   
                    <option value="" >Please select</option>
                    <option value="Recommend" >Recommend</option>
                    <option value="Non-Recommend" >Non-Recommend</option>                   
                </select>
        </label>
      </div>
      </div>  

     <div className='form-group'>
        <label htmlFor="rsm_rh_ch_remarks">
            <span>RSM/ RH/ CH Remarks</span>
              <textarea style={{height:'auto'}} rows="5" id="rsm_rh_ch_remarks" name="rsm_rh_ch_remarks" className='form-control' {...register('rsm_rh_ch_remarks')} value={formCAMRSMRHCHValues.rsm_rh_ch_remarks} onChange={handleCAMRSMRHCHChange} />
        </label>
      </div>

     
     { ( userRoleType === "Regional Sales Manager" || userRoleType === "Regional Head" || userRoleType === "Cluster Head" ) && (
      <div className='col-md-12'>
        <div className="form-group ">
                <button 
                  type="button" 
                  className="row btn btn-primary float-right"
                  onClick={() => handleRSMRHCHDetails()}
                  >
                     {preloaderStatus && (
                          <>
                            <div
                              className="spinner-border small-preloader"
                              role="status"
                            >
                              <span className="visually-hidden">
                                {" "}
                                Loading...
                              </span>
                            </div>
                          </>
                        )}
                    Submit</button>
            </div> 

            <div className="form-group ">&nbsp;</div>
            </div>
      )}

       {rsmRhChLatestHistoryData?.createdByName && (
          <div className="col-md-12 text-right" style={{ textAlign: "right" }}>
            RSM/ RH/ CH : Created by {rsmRhChLatestHistoryData.createdByName} on{" "}
            {rsmRhChLatestHistoryData.created_date}
            <br />
          </div>
        )}
 


<div className='col-md-12'>
      <div className='form-group'>
        <label htmlFor="remark_business_detail">
            <span>Credit Remarks</span>
              <textarea style={{height:'auto'}} rows="5" id="remark_business_detail" name="remark_business_detail" className='form-control' {...register('remark_business_detail')} value={formCAMValues.remark_business_detail} onChange={handleCAMChange} />
        </label>
      </div>
</div>


    </div>                   
 {/* Profile Details TextArea End */}

 
 { /* Section C: REMARKS/COMMENTS :  start here */ }
 <div className="col-md-12" >
 <div className='form-group' >
   <hr/>
       <h5 className='text-center text-primary'>Section C: REMARKS/COMMENTS</h5>
   <hr/>
 </div>
 </div>
 <div className='col-md-12'>
   <hr/> 
     <h6 className='text-primary'>Particulars :</h6>
   <br/>
   </div>
   <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_business_profile">
                         <span>Business profile and Business model</span>
                         <input
                           id='remarks_business_profile'
                           name='remarks_business_profile'
                           className='form-control'
                           {...register('remarks_business_profile')}
                           value={formCAMValues.remarks_business_profile}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_major_activity">
                         <span>Major Activity</span>
                         <input
                           id='remarks_major_activity'
                           name='remarks_major_activity'
                           className='form-control'
                           {...register('remarks_major_activity')}
                           value={formCAMValues.remarks_major_activity}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_business_vintage">
                         <span>Business Vintage</span>
                         <input
                           id='remarks_business_vintage'
                           name='remarks_business_vintage'
                           className='form-control'
                           {...register('remarks_business_vintage')}
                           value={formCAMValues.remarks_business_vintage}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_business_validation_proof">
                         <span>Business Validation Proof</span>
                         <select
                               id='remarks_business_validation_proof'
                               name='remarks_business_validation_proof'
                               className="form-select"
                               {...register('remarks_business_validation_proof')}
                               value={formCAMValues.remarks_business_validation_proof}
                               onChange={handleCAMChange}>
                               <option value='' > Please Select </option>
                               {
                                 businessValidationProofArr.length > 0 && businessValidationProofArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                         </label>
                       </div>
                       </div>
  <div className='col-md-12'>
   <hr/> 
     <h6 className='text-primary'>Customer Due Diligence Check and Comments :</h6>
   <br/>
   </div>
   <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_turnover_income">
                         <span>Turnover / Income</span>
                         <select
                               id='remarks_turnover_income'
                               name='remarks_turnover_income'
                               className="form-select"
                               {...register('remarks_turnover_income')}
                               value={formCAMValues.remarks_turnover_income}
                               onChange={handleCAMChange}>
                               <option value='' > Please select</option>
                               {
                                 turnoverIncomeArr.length > 0 && turnoverIncomeArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                         </label>
                       </div>
                       </div>
 
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_working_capital_cycle">
                         <span>Working capital Cycle</span>
                         <select
                               id='remarks_working_capital_cycle'
                               name='remarks_working_capital_cycle'
                               className="form-select"
                               {...register('remarks_working_capital_cycle')}
                               value={formCAMValues.remarks_working_capital_cycle}
                               onChange={handleCAMChange}>
                               <option value='' > Please select</option>
                               {
                                 workingCapitalCycleArr.length > 0 && workingCapitalCycleArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                         </label>
                       </div>
                       </div>
 
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_credit_bureau_remarks_commercial">
                         <span>Credit Bureau Remarks (Commercial If Done)</span>
                         <input
                           id='remarks_credit_bureau_remarks_commercial'
                           name='remarks_credit_bureau_remarks_commercial'
                           className='form-control'
                           {...register('remarks_credit_bureau_remarks_commercial')}
                           value={formCAMValues.remarks_credit_bureau_remarks_commercial}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_work_order_contracts">
                         <span>Work Order / Contracts</span>
                         <input
                           id='remarks_work_order_contracts'
                           name='remarks_work_order_contracts'
                           className='form-control'
                           {...register('remarks_work_order_contracts')}
                           value={formCAMValues.remarks_work_order_contracts}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-12'>
   <hr/> 
     <h6 className='text-primary'>Banking  :</h6>
   <br/>
   </div>
 
    
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_bank_name">
                         <span>Bank Name <a style={{ color: "red" }}>*</a></span>
                         <input
                           id='remarks_bank_name'
                           name='remarks_bank_name'
                           className='form-control'
                           {...register('remarks_bank_name')}
                           value={formCAMValues.remarks_bank_name}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>

     <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_account_holder_name">
                         <span>Account Holder Name <a style={{ color: "red" }}>*</a></span>
                         <input
                           id='remarks_account_holder_name'
                           name='remarks_account_holder_name'
                           className='form-control'
                           {...register('remarks_account_holder_name')}
                           value={formCAMValues.remarks_account_holder_name}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>                     
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_account_no">
                         <span>A/c No <a style={{ color: "red" }}>*</a></span>
                         <input
                           id='remarks_account_no'
                           name='remarks_account_no'
                           className='form-control'
                           {...register('remarks_account_no')}
                           value={formCAMValues.remarks_account_no}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_ifsc_code">
                         <span>IFSC Code <a style={{ color: "red" }}>*</a></span>
                         <input
                           id='remarks_ifsc_code'
                           name='remarks_ifsc_code'
                           className='form-control'
                           {...register('remarks_ifsc_code')}
                           value={formCAMValues.remarks_ifsc_code}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_type_of_account">
                         <span>Type of Account <a style={{ color: "red" }}>*</a></span>
                             <select
                               id='remarks_type_of_account'
                               name='remarks_type_of_account'
                               className="form-select"
                               {...register('remarks_type_of_account')}
                               value={formCAMValues.remarks_type_of_account}
                               onChange={handleCAMChange}>
                               <option value='' > Please Select </option>
                               {
                                 accountTypeArr.length > 0 && accountTypeArr.map((option) => (
                                   <option value={option.name} >
                                     {option.name}
                                   </option>
                                 ))
                               }
                             </select>
                           </label>
                         </div>
                       </div> 
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_abb_utilization">
                         <span>ABB / Utilization</span>
                         <input
                           id='remarks_abb_utilization'
                           name='remarks_abb_utilization'
                           className='form-control'
                           {...register('remarks_abb_utilization')}
                           value={formCAMValues.remarks_abb_utilization}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_total_credits">
                         <span>Total Credits</span>
                         <input
                           id='remarks_total_credits'
                           name='remarks_total_credits'
                           className='form-control'
                           {...register('remarks_total_credits')}
                           value={formCAMValues.remarks_total_credits}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_iw_rtn_per_and_count">
                         <span>I/W Rtn % and count</span>
                         <input
                           id='remarks_iw_rtn_per_and_count'
                           name='remarks_iw_rtn_per_and_count'
                           className='form-control'
                           {...register('remarks_iw_rtn_per_and_count')}
                           value={formCAMValues.remarks_iw_rtn_per_and_count}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_ow_rtn_per_and_count">
                         <span>O/W Rtn % and count</span>
                         <input
                           id='remarks_ow_rtn_per_and_count'
                           name='remarks_ow_rtn_per_and_count'
                           className='form-control'
                           {...register('remarks_ow_rtn_per_and_count')}
                           value={formCAMValues.remarks_ow_rtn_per_and_count}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_notes">
                         <span>Remarks</span>
                         <input
                           id='remarks_notes'
                           name='remarks_notes'
                           className='form-control'
                           {...register('remarks_notes')}
                           value={formCAMValues.remarks_notes}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_previous_em_ii_uam">
                         <span>Previous EM-II/ UAM</span>
                         <input
                           id='remarks_previous_em_ii_uam'
                           name='remarks_previous_em_ii_uam'
                           className='form-control'
                           {...register('remarks_previous_em_ii_uam')}
                           value={formCAMValues.remarks_previous_em_ii_uam}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>
 
 <div className='col-md-12'>
   <hr/>
 </div>
  
  
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_existing_loan_details">
                         <span>Existing Loan Details (Remarks)</span>
                         <input
                           id='remarks_existing_loan_details'
                           name='remarks_existing_loan_details'
                           className='form-control'
                           {...register('remarks_existing_loan_details')}
                           value={formCAMValues.remarks_existing_loan_details}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>	
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_credit_bureau_remarks">
                         <span>Credit Bureau Remarks</span>
                         <input
                           id='remarks_credit_bureau_remarks'
                           name='remarks_credit_bureau_remarks'
                           className='form-control'
                           {...register('remarks_credit_bureau_remarks')}
                           value={formCAMValues.remarks_credit_bureau_remarks}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div> 											
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_current_vehicle_deployment">
                         <span>Current Vehicle Deployment - Load and Routes</span>
                         <input
                           id='remarks_current_vehicle_deployment'
                           name='remarks_current_vehicle_deployment'
                           className='form-control'
                           {...register('remarks_current_vehicle_deployment')}
                           value={formCAMValues.remarks_current_vehicle_deployment}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div>												
 
 <div className='col-md-3'>
                       <div className='form-group'>
                         <label htmlFor="remarks_financials_related_remark">
                         <span>Financials Related Remark</span>
                         <input
                           id='remarks_financials_related_remark'
                           name='remarks_financials_related_remark'
                           className='form-control'
                           {...register('remarks_financials_related_remark')}
                           value={formCAMValues.remarks_financials_related_remark}
                           onChange={handleCAMChange}
                           
                         />
                         </label>
                       </div>
                       </div> 
 
   { /* Section C: REMARKS/COMMENTS :  END here */ }
 
 
   { /* Section D: Due Dilligence and Onboarding checks :  start here */ }
 <div className="col-md-12" >
 <div className='form-group' >
   <hr/>
       <h5 className='text-center text-primary'>Section D: Due Dilligence and Onboarding checks</h5>
   <hr/>
 </div>
 </div>
 
 <div className=" col-md-12" >
      <div className="row">
         <div className="col-md-3" >
          <b>Particulars/Report  </b> 
         </div>   
         <div className="col-md-3" > 
         <b>Requirement</b>
         </div> 
         <div className="col-md-3" > 
         <b>Status</b>
         </div> 
         <div className="col-md-3" >
         <b>Remarks</b>  
         </div> 
     </div> 
       
       <div className="col-md-12" > 
       <hr/>
       </div> 
       
       <div className="row">
     <div className="col-md-3" >
      Personal Discussion (PD)
     </div>   
     <div className="col-md-3" > 
       <div className="form-group"><label htmlFor="lead-profile" >
         <select
           id='dilligence_pd_requirement'
           name='dilligence_pd_requirement'
           className="form-select"
           {...register('dilligence_pd_requirement')}
           value={formCAMValues.dilligence_pd_requirement}
           onChange={handleCAMChange}>
           {
           requirementOptions.length > 0 && requirementOptions.map((option) => (
             <option key={option.name} value={option.name} >
             {option.name}
             </option>
           ))
           }
         </select>
         </label></div>
     </div> 
     <div className="col-md-3" > 
         <div className="form-group"><label htmlFor="lead-profile" >
         <select
           id='dilligence_pd_status'
           name='dilligence_pd_status'
           className="form-select"
           {...register('dilligence_pd_status')}
           value={formCAMValues.dilligence_pd_status}
           onChange={handleCAMChange}>
           {
           statusOptions.length > 0 && statusOptions.map((option) => (
             <option key={option.name} value={option.name} >
             {option.name}
             </option>
           ))
           }
         </select>
         </label></div>
     </div> 
     <div className="col-md-3" >
     <div className="form-group"><label htmlFor="">
       <input
         id='dilligence_pd_remarks'
         name='dilligence_pd_remarks'
         className='form-control'
         {...register('dilligence_pd_remarks')}
         value={formCAMValues.dilligence_pd_remarks}
         onChange={handleCAMChange}
       />
       </label></div>
     </div> 
 </div> 
 
  <div className="row">
     <div className="col-md-3" >
      Proforma Invoice 
     </div>   
     <div className="col-md-3" > 
       <div className="form-group"><label htmlFor="lead-profile" >
         <select
           id='dilligence_proformainvoice_requirement'
           name='dilligence_proformainvoice_requirement'
           className="form-select"
           {...register('dilligence_proformainvoice_requirement')}
           value={formCAMValues.dilligence_proformainvoice_requirement}
           onChange={handleCAMChange}>
           {
           requirementOptions.length > 0 && requirementOptions.map((option) => (
             <option key={option.name} value={option.name} >
             {option.name}
             </option>
           ))
           }
         </select>
         </label></div>
     </div> 
     <div className="col-md-3" > 
         <div className="form-group"><label htmlFor="lead-profile" >
         <select
           id='dilligence_proformainvoice_status'
           name='dilligence_proformainvoice_status'
           className="form-select"
           {...register('dilligence_proformainvoice_status')}
           value={formCAMValues.dilligence_proformainvoice_status}
           onChange={handleCAMChange}>
           {
           statusOptions.length > 0 && statusOptions.map((option) => (
             <option key={option.name} value={option.name} >
             {option.name}
             </option>
           ))
           }
         </select>
         </label></div>
     </div> 
     <div className="col-md-3" >
     <div className="form-group"><label htmlFor="">
       <input
         id='dilligence_proformainvoice_remarks'
         name='dilligence_proformainvoice_remarks'
         className='form-control'
         {...register('dilligence_proformainvoice_remarks')}
         value={formCAMValues.dilligence_proformainvoice_remarks}
         onChange={handleCAMChange}
       />
       </label></div>
     </div> 
 </div> 
 
  <div className="row">
     <div className="col-md-3" >
      KYC 
     </div>   
     <div className="col-md-3" > 
       <div className="form-group"><label htmlFor="lead-profile" >
         <select
           id='dilligence_kyc_requirement'
           name='dilligence_kyc_requirement'
           className="form-select"
           {...register('dilligence_kyc_requirement')}
           value={formCAMValues.dilligence_kyc_requirement}
           onChange={handleCAMChange}>
           {
           requirementOptions.length > 0 && requirementOptions.map((option) => (
             <option key={option.name} value={option.name} >
             {option.name}
             </option>
           ))
           }
         </select>
         </label></div>
     </div> 
     <div className="col-md-3" > 
         <div className="form-group"><label htmlFor="lead-profile" >
         <select
           id='dilligence_kyc_status'
           name='dilligence_kyc_status'
           className="form-select"
           {...register('dilligence_kyc_status')}
           value={formCAMValues.dilligence_kyc_status}
           onChange={handleCAMChange}>
           {
           statusOptions.length > 0 && statusOptions.map((option) => (
             <option key={option.name} value={option.name} >
             {option.name}
             </option>
           ))
           }
         </select>
         </label></div>
     </div> 
     <div className="col-md-3" >
     <div className="form-group"><label htmlFor="">
       <input
         id='dilligence_kyc_remarks'
         name='dilligence_kyc_remarks'
         className='form-control'
         {...register('dilligence_kyc_remarks')}
         value={formCAMValues.dilligence_kyc_remarks}
         onChange={handleCAMChange}
       />
       </label></div>
     </div> 
 </div> 
 
  <div className="row">
     <div className="col-md-3" >
      Banking 
     </div>   
     <div className="col-md-3" > 
       <div className="form-group"><label htmlFor="lead-profile" >
         <select
           id='dilligence_banking_requirement'
           name='dilligence_banking_requirement'
           className="form-select"
           {...register('dilligence_banking_requirement')}
           value={formCAMValues.dilligence_banking_requirement}
           onChange={handleCAMChange}>
           {
           requirementOptions.length > 0 && requirementOptions.map((option) => (
             <option key={option.name} value={option.name} >
             {option.name}
             </option>
           ))
           }
         </select>
         </label></div>
     </div> 
     <div className="col-md-3" > 
         <div className="form-group"><label htmlFor="lead-profile" >
         <select
           id='dilligence_banking_status'
           name='dilligence_banking_status'
           className="form-select"
           {...register('dilligence_banking_status')}
           value={formCAMValues.dilligence_banking_status}
           onChange={handleCAMChange}>
           {
           statusOptions.length > 0 && statusOptions.map((option) => (
             <option key={option.name} value={option.name} >
             {option.name}
             </option>
           ))
           }
         </select>
         </label></div>
     </div> 
     <div className="col-md-3" >
     <div className="form-group"><label htmlFor="">
       <input
         id='dilligence_banking_remarks'
         name='dilligence_banking_remarks'
         className='form-control'
         {...register('dilligence_banking_remarks')}
         value={formCAMValues.dilligence_banking_remarks}
         onChange={handleCAMChange}
       />
       </label></div>
     </div> 
 </div> 
 
 
  <div className="row">
     <div className="col-md-3" >
      GST 
     </div>   
     <div className="col-md-3" > 
       <div className="form-group"><label htmlFor="lead-profile" >
         <select
           id='dilligence_gst_requirement'
           name='dilligence_gst_requirement'
           className="form-select"
           {...register('dilligence_gst_requirement')}
           value={formCAMValues.dilligence_gst_requirement}
           onChange={handleCAMChange}>
           {
           requirementOptions.length > 0 && requirementOptions.map((option) => (
             <option key={option.name} value={option.name} >
             {option.name}
             </option>
           ))
           }
         </select>
         </label></div>
     </div> 
     <div className="col-md-3" > 
         <div className="form-group"><label htmlFor="lead-profile" >
         <select
           id='dilligence_gst_status'
           name='dilligence_gst_status'
           className="form-select"
           {...register('dilligence_gst_status')}
           value={formCAMValues.dilligence_gst_status}
           onChange={handleCAMChange}>
           {
           statusOptions.length > 0 && statusOptions.map((option) => (
             <option key={option.name} value={option.name} >
             {option.name}
             </option>
           ))
           }
         </select>
         </label></div>
     </div> 
     <div className="col-md-3" >
     <div className="form-group"><label htmlFor="">
       <input
         id='dilligence_gst_remarks'
         name='dilligence_gst_remarks'
         className='form-control'
         {...register('dilligence_gst_remarks')}
         value={formCAMValues.dilligence_gst_remarks}
         onChange={handleCAMChange}
       />
       </label></div>
     </div> 
 </div> 
 
  <div className="row">
     <div className="col-md-3" >
      Financials 
     </div>   
     <div className="col-md-3" > 
       <div className="form-group"><label htmlFor="lead-profile" >
         <select
           id='dilligence_financials_requirement'
           name='dilligence_financials_requirement'
           className="form-select"
           {...register('dilligence_financials_requirement')}
           value={formCAMValues.dilligence_financials_requirement}
           onChange={handleCAMChange}>
           {
           requirementOptions.length > 0 && requirementOptions.map((option) => (
             <option key={option.name} value={option.name} >
             {option.name}
             </option>
           ))
           }
         </select>
         </label></div>
     </div> 
     <div className="col-md-3" > 
         <div className="form-group"><label htmlFor="lead-profile" >
         <select
           id='dilligence_financials_status'
           name='dilligence_financials_status'
           className="form-select"
           {...register('dilligence_financials_status')}
           value={formCAMValues.dilligence_financials_status}
           onChange={handleCAMChange}>
           {
           statusOptions.length > 0 && statusOptions.map((option) => (
             <option key={option.name} value={option.name} >
             {option.name}
             </option>
           ))
           }
         </select>
         </label></div>
     </div> 
     <div className="col-md-3" >
     <div className="form-group"><label htmlFor="">
       <input
         id='dilligence_financials_remarks'
         name='dilligence_financials_remarks'
         className='form-control'
         {...register('dilligence_financials_remarks')}
         value={formCAMValues.dilligence_financials_remarks}
         onChange={handleCAMChange}
       />
       </label></div>
     </div> 
 </div> 
     
 </div>
 { /* Section D: Due Dilligence and Onboarding checks :  end here */ }
 
 
 { /* Section E: Selection Criteria / Deviations :  start here */ }
 <div className="col-md-12" >
 <div className='form-group' >
   <hr/>
       <h5 className='text-center text-primary'>Section E: Selection Criteria / Deviations</h5>
   <hr/>
 </div>
 </div>
 
   <div className=" col-md-12" >
      <div className="row">
       <div className="col-md-2" >
        <b>Parameters  </b> 
       </div>   
       <div className="col-md-2" > 
       <b>Brand (N) / Distributor(N-1) - Standard criteria </b>
       </div> 
       <div className="col-md-2" > 
       <b>Norms Met/Not Met </b>
       </div> 
       <div className="col-md-2" >
       <b>Deviation </b>  
       </div> 
       <div className="col-md-2" > 
       <b>Deviation Approval </b>
       </div> 
       <div className="col-md-2" > 
       <b>Mitigation (If Norms not met)</b>
       </div>   
       </div> 
 
       <div className="col-md-12" > 
         <hr/>
       </div> 
 
       <div className="row">
       <div className="col-md-2 border-right-grey" >
     Negative Profile Check  
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_npc_standard_criteria">
       
       <input
         id='dp_npc_standard_criteria'
         name='dp_npc_standard_criteria'
         className='form-control'
         {...register('dp_npc_standard_criteria')}
         value={formCAMValues.dp_npc_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_npc_norms'
       name='dp_npc_norms'
       className="form-select"
       {...register('dp_npc_norms')}
       value={formCAMValues.dp_npc_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     No Deviation Allowed   
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_npc_deviation_approval">
       
       <input
         id='dp_npc_deviation_approval'
         name='dp_npc_deviation_approval'
         className='form-control'
         {...register('dp_npc_deviation_approval')}
         value={formCAMValues.dp_npc_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_npc_mitigation">
       
       <input
         id='dp_npc_mitigation'
         name='dp_npc_mitigation'
         className='form-control'
         {...register('dp_npc_mitigation')}
         value={formCAMValues.dp_npc_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div>   
 </div>
 
 <div className="row">
       <div className="col-md-2 border-right-grey" >
     Credit Free Vehicle in fleet 
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_cfvif_standard_criteria">
       
       <input
         id='dp_cfvif_standard_criteria'
         name='dp_cfvif_standard_criteria'
         className='form-control'
         {...register('dp_cfvif_standard_criteria')}
         value={formCAMValues.dp_cfvif_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_cfvif_norms'
       name='dp_cfvif_norms'
       className="form-select"
       {...register('dp_cfvif_norms')}
       value={formCAMValues.dp_cfvif_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     Deviation allowed upto 0% subject to mitigants (income, RTR)   
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_cfvif_deviation_approval">
       
       <input
         id='dp_cfvif_deviation_approval'
         name='dp_cfvif_deviation_approval'
         className='form-control'
         {...register('dp_cfvif_deviation_approval')}
         value={formCAMValues.dp_cfvif_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_cfvif_mitigation">
       
       <input
         id='dp_cfvif_mitigation'
         name='dp_cfvif_mitigation'
         className='form-control'
         {...register('dp_cfvif_mitigation')}
         value={formCAMValues.dp_cfvif_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div>   
 </div>
 
 <div className="row">
       <div className="col-md-2 border-right-grey" >
     Asset Income Expense viability  / Cost Rationalisation (In case of Captive Use) and FOIR Check  
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_aievcr_standard_criteria">
       
       <input
         id='dp_aievcr_standard_criteria'
         name='dp_aievcr_standard_criteria'
         className='form-control'
         {...register('dp_aievcr_standard_criteria')}
         value={formCAMValues.dp_aievcr_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_aievcr_norms'
       name='dp_aievcr_norms'
       className="form-select"
       {...register('dp_aievcr_norms')}
       value={formCAMValues.dp_aievcr_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     No Deviation Allowed  
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_aievcr_deviation_approval">
       
       <input
         id='dp_aievcr_deviation_approval'
         name='dp_aievcr_deviation_approval'
         className='form-control'
         {...register('dp_aievcr_deviation_approval')}
         value={formCAMValues.dp_aievcr_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_aievcr_mitigation">
       
       <input
         id='dp_aievcr_mitigation'
         name='dp_aievcr_mitigation'
         className='form-control'
         {...register('dp_aievcr_mitigation')}
         value={formCAMValues.dp_aievcr_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div>   
 </div>
 
 <div className="row">
       <div className="col-md-2 border-right-grey" >
     Maximum LTV  
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_maxltv_standard_criteria">
       
       <input
         id='dp_maxltv_standard_criteria'
         name='dp_maxltv_standard_criteria'
         className='form-control'
         {...register('dp_maxltv_standard_criteria')}
         value={formCAMValues.dp_maxltv_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_maxltv_norms'
       name='dp_maxltv_norms'
       className="form-select"
       {...register('dp_maxltv_norms')}
       value={formCAMValues.dp_maxltv_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     Upto 93%
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_maxltv_deviation_approval">
       
       <input
         id='dp_maxltv_deviation_approval'
         name='dp_maxltv_deviation_approval'
         className='form-control'
         {...register('dp_maxltv_deviation_approval')}
         value={formCAMValues.dp_maxltv_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_maxltv_mitigation">
       
       <input
         id='dp_maxltv_mitigation'
         name='dp_maxltv_mitigation'
         className='form-control'
         {...register('dp_maxltv_mitigation')}
         value={formCAMValues.dp_maxltv_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div>   
 </div>
 
 <div className="row">
       <div className="col-md-2 border-right-grey" >
     Stability (time in city)  
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_stabilitytic_standard_criteria">
       
       <input
         id='dp_stabilitytic_standard_criteria'
         name='dp_stabilitytic_standard_criteria'
         className='form-control'
         {...register('dp_stabilitytic_standard_criteria')}
         value={formCAMValues.dp_stabilitytic_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_stabilitytic_norms'
       name='dp_stabilitytic_norms'
       className="form-select"
       {...register('dp_stabilitytic_norms')}
       value={formCAMValues.dp_stabilitytic_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     No Deviation Allowed  
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_stabilitytic_deviation_approval">
       
       <input
         id='dp_stabilitytic_deviation_approval'
         name='dp_stabilitytic_deviation_approval'
         className='form-control'
         {...register('dp_stabilitytic_deviation_approval')}
         value={formCAMValues.dp_stabilitytic_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_stabilitytic_mitigation">
       
       <input
         id='dp_stabilitytic_mitigation'
         name='dp_stabilitytic_mitigation'
         className='form-control'
         {...register('dp_stabilitytic_mitigation')}
         value={formCAMValues.dp_stabilitytic_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div>   
 </div>
 
 <div className="row">
       <div className="col-md-2 border-right-grey" >
     Property Ownership/ Stability  
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_pwstability_standard_criteria">
       
       <input
         id='dp_pwstability_standard_criteria'
         name='dp_pwstability_standard_criteria'
         className='form-control'
         {...register('dp_pwstability_standard_criteria')}
         value={formCAMValues.dp_pwstability_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_pwstability_norms'
       name='dp_pwstability_norms'
       className="form-select"
       {...register('dp_pwstability_norms')}
       value={formCAMValues.dp_pwstability_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     Deviation Allowed for Rented Premises 
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_pwstability_deviation_approval">
       
       <input
         id='dp_pwstability_deviation_approval'
         name='dp_pwstability_deviation_approval'
         className='form-control'
         {...register('dp_pwstability_deviation_approval')}
         value={formCAMValues.dp_pwstability_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_pwstability_mitigation">
       
       <input
         id='dp_pwstability_mitigation'
         name='dp_pwstability_mitigation'
         className='form-control'
         {...register('dp_pwstability_mitigation')}
         value={formCAMValues.dp_pwstability_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div>   
 </div>
 
 <div className="row">
       <div className="col-md-2 border-right-grey" >
     Required Co Applicant / Guarantor on Loan Structure 
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_rcpgls_standard_criteria">
       
       <input
         id='dp_rcpgls_standard_criteria'
         name='dp_rcpgls_standard_criteria'
         className='form-control'
         {...register('dp_rcpgls_standard_criteria')}
         value={formCAMValues.dp_rcpgls_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_rcpgls_norms'
       name='dp_rcpgls_norms'
       className="form-select"
       {...register('dp_rcpgls_norms')}
       value={formCAMValues.dp_rcpgls_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     No Deviation Allowed 
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_rcpgls_deviation_approval">
       
       <input
         id='dp_rcpgls_deviation_approval'
         name='dp_rcpgls_deviation_approval'
         className='form-control'
         {...register('dp_rcpgls_deviation_approval')}
         value={formCAMValues.dp_rcpgls_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_rcpgls_mitigation">
       
       <input
         id='dp_rcpgls_mitigation'
         name='dp_rcpgls_mitigation'
         className='form-control'
         {...register('dp_rcpgls_mitigation')}
         value={formCAMValues.dp_rcpgls_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div>   
 </div>
 
 <div className="row">
       <div className="col-md-2 border-right-grey" >
     Business Stability / Driving Experience
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_bsde_standard_criteria">
       
       <input
         id='dp_bsde_standard_criteria'
         name='dp_bsde_standard_criteria'
         className='form-control'
         {...register('dp_bsde_standard_criteria')}
         value={formCAMValues.dp_bsde_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_bsde_norms'
       name='dp_bsde_norms'
       className="form-select"
       {...register('dp_bsde_norms')}
       value={formCAMValues.dp_bsde_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     Deviation allowed upto 1 year - Business Stability For FTU /DCO - No deviation allowed on DL experience
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_bsde_deviation_approval">
       
       <input
         id='dp_bsde_deviation_approval'
         name='dp_bsde_deviation_approval'
         className='form-control'
         {...register('dp_bsde_deviation_approval')}
         value={formCAMValues.dp_bsde_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_bsde_mitigation">
       
       <input
         id='dp_bsde_mitigation'
         name='dp_bsde_mitigation'
         className='form-control'
         {...register('dp_bsde_mitigation')}
         value={formCAMValues.dp_bsde_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div>   
 </div>
 
 <div className="row">
       <div className="col-md-2 border-right-grey" >
     Net Worth
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_nw_standard_criteria">
       
       <input
         id='dp_nw_standard_criteria'
         name='dp_nw_standard_criteria'
         className='form-control'
         {...register('dp_nw_standard_criteria')}
         value={formCAMValues.dp_nw_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_nw_norms'
       name='dp_nw_norms'
       className="form-select"
       {...register('dp_nw_norms')}
       value={formCAMValues.dp_nw_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     Deviation allowed subject to positive cash profit
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_nw_deviation_approval">
       
       <input
         id='dp_nw_deviation_approval'
         name='dp_nw_deviation_approval'
         className='form-control'
         {...register('dp_nw_deviation_approval')}
         value={formCAMValues.dp_nw_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_nw_mitigation">
       
       <input
         id='dp_nw_mitigation'
         name='dp_nw_mitigation'
         className='form-control'
         {...register('dp_nw_mitigation')}
         value={formCAMValues.dp_nw_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div>   
 </div>
 
 <div className="row">
       <div className="col-md-2 border-right-grey" >
     Dedupe Checks
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_dc_standard_criteria">
       
       <input
         id='dp_dc_standard_criteria'
         name='dp_dc_standard_criteria'
         className='form-control'
         {...register('dp_dc_standard_criteria')}
         value={formCAMValues.dp_dc_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_dc_norms'
       name='dp_dc_norms'
       className="form-select"
       {...register('dp_dc_norms')}
       value={formCAMValues.dp_dc_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     No Deviation Allowed  
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_dc_deviation_approval">
       
       <input
         id='dp_dc_deviation_approval'
         name='dp_dc_deviation_approval'
         className='form-control'
         {...register('dp_dc_deviation_approval')}
         value={formCAMValues.dp_dc_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_dc_mitigation">
       
       <input
         id='dp_dc_mitigation'
         name='dp_dc_mitigation'
         className='form-control'
         {...register('dp_dc_mitigation')}
         value={formCAMValues.dp_dc_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div>   
 </div>
 
 <div className="row">
       <div className="col-md-2 border-right-grey" >
     Bureau Check
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_bureaucheck_standard_criteria">
       
       <input
         id='dp_bureaucheck_standard_criteria'
         name='dp_bureaucheck_standard_criteria'
         className='form-control'
         {...register('dp_bureaucheck_standard_criteria')}
         value={formCAMValues.dp_bureaucheck_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_bureaucheck_norms'
       name='dp_bureaucheck_norms'
       className="form-select"
       {...register('dp_bureaucheck_norms')}
       value={formCAMValues.dp_bureaucheck_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     No Deviation Allowed
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_bureaucheck_deviation_approval">
       
       <input
         id='dp_bureaucheck_deviation_approval'
         name='dp_bureaucheck_deviation_approval'
         className='form-control'
         {...register('dp_bureaucheck_deviation_approval')}
         value={formCAMValues.dp_bureaucheck_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_bureaucheck_mitigation">
       
       <input
         id='dp_bureaucheck_mitigation'
         name='dp_bureaucheck_mitigation'
         className='form-control'
         {...register('dp_bureaucheck_mitigation')}
         value={formCAMValues.dp_bureaucheck_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div>   
 </div>
 
 <div className="row">
       <div className="col-md-2 border-right-grey" >
     Banking Criteria
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_bankingcriteria_standard_criteria">
       
       <input
         id='dp_bankingcriteria_standard_criteria'
         name='dp_bankingcriteria_standard_criteria'
         className='form-control'
         {...register('dp_bankingcriteria_standard_criteria')}
         value={formCAMValues.dp_bankingcriteria_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_bankingcriteria_norms'
       name='dp_bankingcriteria_norms'
       className="form-select"
       {...register('dp_bankingcriteria_norms')}
       value={formCAMValues.dp_bankingcriteria_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     Banking Norms Not Met   
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_bankingcriteria_deviation_approval">
       
       <input
         id='dp_bankingcriteria_deviation_approval'
         name='dp_bankingcriteria_deviation_approval'
         className='form-control'
         {...register('dp_bankingcriteria_deviation_approval')}
         value={formCAMValues.dp_bankingcriteria_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_bankingcriteria_mitigation">
       
       <input
         id='dp_bankingcriteria_mitigation'
         name='dp_bankingcriteria_mitigation'
         className='form-control'
         {...register('dp_bankingcriteria_mitigation')}
         value={formCAMValues.dp_bankingcriteria_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div>   
 </div>
 
 <div className="row">
       <div className="col-md-2 border-right-grey" >
     GST Criteria
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_gstcriteria_standard_criteria">
       
       <input
         id='dp_gstcriteria_standard_criteria'
         name='dp_gstcriteria_standard_criteria'
         className='form-control'
         {...register('dp_gstcriteria_standard_criteria')}
         value={formCAMValues.dp_gstcriteria_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_gstcriteria_norms'
       name='dp_gstcriteria_norms'
       className="form-select"
       {...register('dp_gstcriteria_norms')}
       value={formCAMValues.dp_gstcriteria_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     GST Norms Not Met   
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_gstcriteria_deviation_approval">
       
       <input
         id='dp_gstcriteria_deviation_approval'
         name='dp_gstcriteria_deviation_approval'
         className='form-control'
         {...register('dp_gstcriteria_deviation_approval')}
         value={formCAMValues.dp_gstcriteria_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_gstcriteria_mitigation">
       
       <input
         id='dp_gstcriteria_mitigation'
         name='dp_gstcriteria_mitigation'
         className='form-control'
         {...register('dp_gstcriteria_mitigation')}
         value={formCAMValues.dp_gstcriteria_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div>   
 </div>
 
 <div className="row">
       <div className="col-md-2 border-right-grey" >
     Financial Criteria
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_financialcriteria_standard_criteria">
       
       <input
         id='dp_financialcriteria_standard_criteria'
         name='dp_financialcriteria_standard_criteria'
         className='form-control'
         {...register('dp_financialcriteria_standard_criteria')}
         value={formCAMValues.dp_financialcriteria_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_financialcriteria_norms'
       name='dp_financialcriteria_norms'
       className="form-select"
       {...register('dp_financialcriteria_norms')}
       value={formCAMValues.dp_financialcriteria_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     Financial Norms Not Met    
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_financialcriteria_deviation_approval">
       
       <input
         id='dp_financialcriteria_deviation_approval'
         name='dp_financialcriteria_deviation_approval'
         className='form-control'
         {...register('dp_financialcriteria_deviation_approval')}
         value={formCAMValues.dp_financialcriteria_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_financialcriteria_mitigation">
       
       <input
         id='dp_financialcriteria_mitigation'
         name='dp_financialcriteria_mitigation'
         className='form-control'
         {...register('dp_financialcriteria_mitigation')}
         value={formCAMValues.dp_financialcriteria_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div>   
 </div>
 
 <div className="row">
       <div className="col-md-2 border-right-grey" >
     Additional Checks for Strategic Customer
       </div>   
       <div className="col-md-2" > 
        <div className='form-group'>
       <label htmlFor="dp_acfsc_standard_criteria">
       
       <input
         id='dp_acfsc_standard_criteria'
         name='dp_acfsc_standard_criteria'
         className='form-control'
         {...register('dp_acfsc_standard_criteria')}
         value={formCAMValues.dp_acfsc_standard_criteria}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <label htmlFor="lead-profile" >
      <select
       id='dp_acfsc_norms'
       name='dp_acfsc_norms'
       className="form-select"
       {...register('dp_acfsc_norms')}
       value={formCAMValues.dp_acfsc_norms}
       onChange={handleCAMChange}>
        {
       normsMetOptions.length > 0 && normsMetOptions.map((option) => (
         <option value={option.id} >
         {option.name}
         </option>
       ))
       }
     </select>
     </label>
       </div> 
       <div className="col-md-2" >
     Any other deviations    
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_acfsc_deviation_approval">
       
       <input
         id='dp_acfsc_deviation_approval'
         name='dp_acfsc_deviation_approval'
         className='form-control'
         {...register('dp_acfsc_deviation_approval')}
         value={formCAMValues.dp_acfsc_deviation_approval}
         onChange={handleCAMChange}
         readOnly="true"
       />
       </label>
       </div>
       </div> 
       <div className="col-md-2" > 
     <div className='form-group'>
       <label htmlFor="dp_acfsc_mitigation">
       
       <input
         id='dp_acfsc_mitigation'
         name='dp_acfsc_mitigation'
         className='form-control'
         {...register('dp_acfsc_mitigation')}
         value={formCAMValues.dp_acfsc_mitigation}
         onChange={handleCAMChange}
       />
       </label>
       </div>
       </div> 


 </div>
   </div>
 
 
 { /* Section E: Selection Criteria / Deviations :  end here  */ }

 </div>

 
        <div className= {showEditDiv ? "row d-none":"row"}>
            <CustomerAssessmentNoteViewPage
                                       leadInfo={leadInfo}
                                       formCAMValues={formCAMValues}
                                       anchorCategories={anchorCategories} 
                                       speciallyAbledArr={speciallyAbledArr}
                                       handleCAMChange ={handleCAMChange}  
                                       residenceTypesArr ={residenceTypesArr}  
                                       bankingUpiArr ={bankingUpiArr} 
                                       constitutionArr={constitutionArr} 
                                       customerTypeArr={customerTypeArr} 
                                       vehicleMakerArr={vehicleMakerArr} 
                                       vehicleUseArr={vehicleUseArr} 
                                       insuranceArr={insuranceArr} 
                                       vehicleModelsArr={vehicleModelsArr} 
                                       setCamTotalPFAmount={props.setCamTotalPFAmount} 
                                       camTotalPFAmount={camTotalPFAmount} 
                                       coapplicantGuarantorRows={coapplicantGuarantorRows}
                                       handleInputChange={handleInputChange}  
                                       businessValidationProofArr={businessValidationProofArr}  
                                       turnoverIncomeArr= {turnoverIncomeArr} 
                                       workingCapitalCycleArr={workingCapitalCycleArr}  
                                       accountTypeArr={accountTypeArr} 
                                       requirementOptions={requirementOptions} 
                                       statusOptions={statusOptions}  
                                       normsMetOptions={normsMetOptions}  
                                       setCAMLTVPercentage={props.setCAMLTVPercentage} 
                                       cAMLTVPercentage={cAMLTVPercentage}
                                       setCAMMarginMoney={props.setCAMMarginMoney}   
                                       cAMMarginMoney={cAMMarginMoney} 
                                       setCamIRRExcludingPF={props.setCamIRRExcludingPF}   
                                       camIRRExcludingPF={camIRRExcludingPF} 
                                      />
        </div>
      </div>


    </>
  );
}


function mapStateToProps(state) {
  return {
    usersData: state.usersData,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(userActions.default, leadBankStatementActions.default, leadActions.default), dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CustomerAssessmentNotePage);